import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { succussNotification } from '@/service/notification';

const state = {
  error: null,
};
const mutations = {
  update_error(state, payload) {
    state.error = payload;
  },
};

const actions = {
  // Adding agent scac to agency organization
  add_agency_scac_to_org: async (
    { commit, rootGetters, dispatch },
    payload
  ) => {
    try {
      await firebase
        .firestore()
        .collection('organizations')
        .doc(rootGetters['auth/get_user'].orgId)
        .update({
          agency_scacs: firebase.firestore.FieldValue.arrayUnion(payload),
        });
      dispatch('add_agency_payment_to_agent', payload);

      succussNotification('SCAC added successfully!');
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Approve/decline the agent invitation

  handle_agent_invitation: async (
    { commit, rootGetters, dispatch },
    payload
  ) => {
    try {
      const { scac, orgId, type, removeScac } = payload;
      const pendingVerificationRef = await firebase
        .firestore()
        .collection('pending_verifications')
        .where('scac', '==', scac)
        .get();
      const orgData = {
        pending_agent_verifications:
          firebase.firestore.FieldValue.arrayRemove(scac),
      };
      const orgCollectionRef = await firebase
        .firestore()
        .collection('organizations');
      if (removeScac) {
        const orgDocs = await orgCollectionRef.where('scac', '==', scac).get();

        if (type === 'declined' && !orgDocs.docs.length) {
          orgData.agency_scacs =
            firebase.firestore.FieldValue.arrayRemove(scac);
        }
      }
      await orgCollectionRef.doc(orgId).update(orgData);

      pendingVerificationRef.docs.map(async (verification) => {
        if (verification?.exists) {
          verification.ref.update({ agency_verification: type });

          const { email } = rootGetters['auth/get_user'];
          const { company } = rootGetters['auth/get_org'];
          const data = verification.data();
          // sending email to agency

          await dispatch('send_agent_activity_email', {
            orgData: data,
            email: email,
            message: `Hello ${company}, You have ${type} the invite from ${scac} successfully`,
          });

          // sending email to agent
          await dispatch('send_agent_activity_email', {
            orgData: data,
            email: data.email,
            message: `Hello ${data.company}, Your invite has ${type} by ${company}`,
            url: `${process.env.VUE_APP_CANONICAL_URL}/dashboard`,
          });
        }
      });

      succussNotification(`Invitation ${type} successfully!`);
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Removing agent scac from agency organization
  remove_scac_from_agency_org: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    const { orgId, scac } = payload;
    try {
      const orgRef = await firebase
        .firestore()
        .collection('organizations')
        .doc(orgId);

      const orgData = (await orgRef.get()).data();

      if (orgData?.pending_agent_verifications?.find((val) => val === scac)) {
        dispatch('handle_agent_invitation', {
          scac: scac,
          orgId: orgId,
          type: 'declined',
        });
      }
      orgRef.update({
        agency_scacs: firebase.firestore.FieldValue.arrayRemove(scac),
      });
      const { docs: organizationDoc } = await firebase
        .firestore()
        .collection('organizations')
        .where('scac', '==', scac)
        .get();

      if (organizationDoc.length) {
        organizationDoc.map(async (agentOrg) => {
          if (agentOrg.data().agency_orgid) {
            await dispatch('remove_agency_payment_from_agent', {
              doc: agentOrg,
              orgId: orgId,
            });
            const { name } = (
              await firebase
                .firestore()
                .collection('users')
                .doc(agentOrg.data().owner_uid)
                .get()
            ).data();
            // Sending notification to agent
            await dispatch(
              'notifications/send_notification',
              {
                type: 'agency_mention_posted',
                recipient: `@${name.replace(/\s+/g, '_')}_${
                  agentOrg.data().orgId
                }`,
                owner: orgData.owner_uid,
                message: `You have been removed from ${orgData?.company} and no longer have access to
              their payment method.`,
                metadata: {
                  agency: {
                    orgId: orgId,
                  },
                },
              },
              { root: true }
            );
          }
        });
      }
      succussNotification('SCAC removed successfully!');
    } catch (error) {
      commit('update_error', error);
    }
  },

  //   copying agency default method to agent  and agency_customer_id to agent doc
  add_agency_payment_to_agent: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    try {
      const { docs: organizationDoc } = await firebase
        .firestore()
        .collection('organizations')
        .where('scac', '==', payload)
        .get();
      if (organizationDoc.length) {
        organizationDoc.map(async (doc) => {
          // Adding agencyOrgId in agent organization
          const orgData = doc.data();
          doc.ref.update({
            agency_orgid: rootGetters['auth/get_user'].orgId,
          });

          // Adding agency customer id to agent stripe documnet
          const stripeDocRef = await firebase
            .firestore()
            .collection('stripe_customers')
            .doc(orgData.owner_uid);

          await stripeDocRef.update({
            agency_customer_id: rootGetters['auth/get_customer'].customer_id,
          });

          // Adding default payment method to agent
          const paymentMethods =
            rootGetters['stripe/get_payment_methods'] || [];
          const collectionRef = stripeDocRef.collection('payment_methods');

          if (paymentMethods.length) {
            const { docs: paymentDocs } = await collectionRef.get();
            if (paymentDocs.length) {
              paymentDocs.forEach(async (doc) => {
                if (doc.data().is_default === true) {
                  await collectionRef.doc(doc.id).update({ is_default: false });
                }
              });
            }
            const agencyPaymentMethods = JSON.parse(
              JSON.stringify(paymentMethods)
            );
            const defaultPaymentMethod = agencyPaymentMethods.find(
              (val) => val.is_default === true
            );
            defaultPaymentMethod.is_agency = true;

            await collectionRef.add(defaultPaymentMethod);
          }
          // sending email to agency
          await dispatch('send_agent_activity_email', {
            orgData: orgData,
            email: rootGetters['auth/get_user'].email,
            message: `Hello ${rootGetters['auth/get_org'].company}, ${orgData.company} has successfully added.`,
          });

          // sending email to agent

          await dispatch('send_agent_activity_email', {
            orgData: orgData,
            email: orgData.email,
            message: `Hello ${orgData?.company}, You are successfully added under ${rootGetters['auth/get_org'].company}`,
          });

          // Sending notification to the agent when agency added scac
          const { name } = (
            await firebase
              .firestore()
              .collection('users')
              .doc(orgData.owner_uid)
              .get()
          ).data();
          await dispatch(
            'notifications/send_notification',
            {
              type: 'agency_mention_posted',
              recipient: `@${name.replace(/\s+/g, '_')}_${orgData.orgId}`,
              owner: rootGetters['auth/get_org'].owner_uid,
              message: `You have been added under  ${rootGetters['auth/get_org'].company} and have access to
              their payment method.`,
              metadata: {
                agency: {
                  orgId: rootGetters['auth/get_user'].orgId,
                },
              },
            },
            { root: true }
          );
        });
      }
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Removing payment method from agent

  remove_agency_payment_from_agent: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    const { orgId, doc } = payload;

    const orgData = doc.data();
    try {
      // removing agency_orgid from agent organization
      await doc.ref.update({
        agency_orgid: firebase.firestore.FieldValue.delete(),
      });

      const stripeDocRef = await firebase
        .firestore()
        .collection('stripe_customers')
        .doc(orgData.owner_uid);

      stripeDocRef.update({
        agency_customer_id: firebase.firestore.FieldValue.delete(),
      });
      const collectionRef = stripeDocRef.collection('payment_methods');

      const { docs: paymentDocs } = await collectionRef.get();
      if (paymentDocs.length) {
        const defaultDoc = paymentDocs?.find(
          (doc) => doc.data().is_agency === true
        );
        if (defaultDoc) {
          await collectionRef.doc(defaultDoc.id).delete();
        }
        if (
          (defaultDoc && paymentDocs.length > 1) ||
          (!defaultDoc && paymentDocs.length > 0)
        ) {
          const paymentData = paymentDocs?.map((val) => val.data());
          const filteredArray = paymentData.filter(
            (obj) => obj.created !== defaultDoc?.data().created
          );
          const defaultCreated = Math.min.apply(
            Math,
            filteredArray.map((ele) => ele.created)
          );

          await collectionRef
            .doc(
              paymentDocs[
                paymentData.findIndex((val) => val.created === defaultCreated)
              ].id
            )
            .update({ is_default: true });
        }
      }
      const orgRef = firebase
        .firestore()
        .collection('organizations')
        .doc(orgId);
      const { email, company } = (await orgRef.get()).data();
      // sending email to agency

      await dispatch('send_agent_activity_email', {
        orgData: orgData,
        email: email,
        message: `Hello ${company}, ${orgData.company} has successfully removed.`,
      });

      // sending email to agent

      await dispatch('send_agent_activity_email', {
        orgData: orgData,
        email: orgData.email,
        message: `Hello ${orgData?.company}, You have been removed from ${company} and no longer have access to
        their payment method.`,
      });
    } catch (error) {
      commit('update_error', error);
    }
  },

  // send invite to the agent from agency
  invite_new_agent: async ({ commit, rootGetters, dispatch }, payload) => {
    const { email, scac } = payload;
    try {
      const invitation = await firebase
        .firestore()
        .collection('invitations')
        .add({
          email: email.toLowerCase(),
          scac,
          agency_org: rootGetters['auth/get_user'].orgId,
        });

      const invite = await invitation.get();

      await firebase
        .firestore()
        .collection('mail')
        .add({
          to: email,
          message: {
            subject: 'Hello from Qualle!',
            html:
              rootGetters['auth/get_user'].email +
              ` invites you to organization ${rootGetters['auth/get_user'].company} ` +
              `.<br /><br /> Use this <a href="${process.env.VUE_APP_CANONICAL_URL}/register?invite=${invite.id}">link</a> to sign up with ${email} ` +
              ' to connect to the organization.<br />Have a good day',
          },
        });
      succussNotification('Invitation sent successfully!');
    } catch (error) {
      commit('update_error', error);
    }
  },

  // agent removes membership from the agency
  revoke_agent_membership: async ({ commit, dispatch }, payload) => {
    try {
      const { agencyOrgId, agencyOwner, scac, orgId } = payload;

      const orgCollectionRef = await firebase
        .firestore()
        .collection('organizations');

      const { docs: organizationDoc } = await orgCollectionRef
        .where('scac', '==', scac)
        .where('agency_orgid', '==', agencyOrgId)
        .get();
      if (organizationDoc.length <= 1) {
        await orgCollectionRef.doc(agencyOrgId).update({
          agency_scacs: firebase.firestore.FieldValue.arrayRemove(scac),
        });
      }
      const orgData = organizationDoc.map((doc) => doc.data());

      const orgIndex = orgData.findIndex((val) => val.orgId === orgId);

      const agentOrg = organizationDoc[orgIndex];

      await dispatch('remove_agency_payment_from_agent', {
        doc: agentOrg,
        orgId: agencyOrgId,
      });
      const { name } = (
        await firebase.firestore().collection('users').doc(agencyOwner).get()
      ).data();
      await succussNotification('Successfully disconnected from agency!');

      await dispatch(
        'notifications/send_notification',
        {
          type: 'agency_mention_posted',
          recipient: `@${name.replace(/\s+/g, '_')}_${agencyOrgId}`,
          owner: agentOrg.data().owner_uid,
          message: `${
            agentOrg.data().company
          } disconnected and no longer have access to your payment method.`,
          metadata: {
            agency: {
              orgId: agencyOrgId,
            },
          },
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // sending agent activity emails
  send_agent_activity_email: async ({ commit, dispatch }, payload) => {
    const { email, orgData, message, url } = payload;
    try {
      await firebase
        .firestore()
        .collection('mail')
        .add({
          to: email,
          template: {
            name: 'agent_activity',
            data: {
              created: getLocalTime().format('MM/DD/YYYY'),
              scac: orgData.scac,
              company: orgData.company,
              type: orgData.org_type,
              title: message,
              url:
                url ||
                `${process.env.VUE_APP_CANONICAL_URL}/settings?page=organization`,
            },
          },
        });
    } catch (error) {
      commit('update_error', error);
    }
  },
};
const getters = {
  get_error: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
